import { render } from "./UpdatePrompt.vue?vue&type=template&id=69161994&scoped=true"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js"

import "./UpdatePrompt.vue?vue&type=style&index=0&id=69161994&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69161994"]])

export default __exports__